declare var $: any;

export class Print {
    static init() {
        $("body").on("click", ".js-print", (e: Event) => {
            e.preventDefault();
            window.print();
        });
    };
};



// WEBPACK FOOTER //
// ./assets/scripts/modules/print.ts